/**
 * Jokkoleen — Utilitaire de normalisation des numéros WhatsApp
 *
 * WhatsApp attend : wa.me/221770978121
 *   ✅  +221 77 097 81 21  →  221770978121
 *   ✅   221770978121      →  221770978121
 *   ✅   770978121         →  221770978121  (local sénégalais 9 chiffres)
 *   ✅  0033687304435      →   33687304435  (français avec préfixe 00)
 *   ✅  +33 6 87 30 44 35  →   33687304435
 *   ✅  0687304435         →   33687304435  (si préfixe 0 seul = local France → on ne devine pas, on laisse)
 */
export function formatWhatsApp(phone) {
  if (!phone) return "";

  // 1. Supprimer espaces, tirets, points, parenthèses
  let d = phone.replace(/[\s\-.()\u00A0]/g, "");

  // 2. Supprimer le + initial
  if (d.startsWith("+")) d = d.slice(1);

  // 3. Supprimer le préfixe international 00 (0033... → 33...)
  if (d.startsWith("00")) d = d.slice(2);

  // 4. Supprimer tout ce qui n'est pas chiffre
  d = d.replace(/\D/g, "");

  // 5. Supprimer les 0 initiaux résiduels (0033 → 33 déjà fait, mais sécurité)
  d = d.replace(/^0+/, "");

  // 6. Numéro local sénégalais sans indicatif (7X XXX XXXX = 9 chiffres)
  //    77, 76, 75, 78, 70, 33 (fixe Dakar)
  if (d.length === 9) {
    d = "221" + d;
  }

  return d;
}

/**
 * Génère une URL WhatsApp à partir d'un numéro brut + message optionnel
 */
export function whatsappUrl(phone, message = "") {
  const num = formatWhatsApp(phone);
  if (!num) return "#";
  const base = `https://wa.me/${num}`;
  return message ? `${base}?text=${encodeURIComponent(message)}` : base;
}
